// extracted by mini-css-extract-plugin
export default {"animated_loader":"AnimatedLoader_animated_loader__qASF2","spin-clockwise":"AnimatedLoader_spin-clockwise__Jqe-m","spin-counter":"AnimatedLoader_spin-counter__X1YPB"};